module.exports = __webpack_public_path__ + "static/media/red-l.fa0561b9.svg";